import { TopBarTopLinkProps } from '../types'
import { ListItemWrapper, ListItemWrapperProps } from './list-item-wrapper'

interface ListItemLinkProps extends Pick<ListItemWrapperProps, 'useDivider'> {
  link: TopBarTopLinkProps
  onClick: () => void
}

export const ListItemLink = ({
  onClick,
  link,
  useDivider = true
}: ListItemLinkProps) => {
  const { translationId, ...rest } = link
  return (
    <ListItemWrapper
      listItemProps={{ onClick, ...rest }}
      listItemTextProps={{ translationId }}
      useDivider={useDivider}
    />
  )
}

type SubItemLinkProps = Omit<ListItemLinkProps, 'useDivider'>

export const SubItemLink = ({ ...props }: SubItemLinkProps) => (
  <ListItemLink {...props} useDivider={false} />
)
